export default "__VITE_ASSET__AXA_dLDK__"